import React, { useEffect, useState } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import AboutEdit from '../EditProfileSections/AboutEdit';
import ContactInfoEdit from '../EditProfileSections/ContactInfoEdit';
import AppoinetementEdit from '../EditProfileSections/AppoinetementEdit';
import ImagesEdit from '../EditProfileSections/ImagesEdit';
import LinksEdit from '../EditProfileSections/LinksEdit';
import ProfileInfoEdit from '../EditProfileSections/ProfileInfoEdit';
import ServicesEdit from '../EditProfileSections/ServicesEdit';
import SocialMediaEdit from '../EditProfileSections/SocialMediaEdit';
import FooterEdit from '../EditProfileSections/FooterEdit';
import Pictures from '../EditProfileSections/Pictures';
import Videos from '../EditProfileSections/Videos';
import ScheduleEdit from '../EditProfileSections/ScheduleEdit';
import CvEdit from '../EditProfileSections/CvEdit';
import '../edit.css';
import Cookies from 'js-cookie';

function EditProfilePage() {
  let userId = Cookies.get('userId');
  let UserToken = Cookies.get('UserSpecialToken');
  const apiUrl = process.env.REACT_APP_BACKEND_URL;
  const initialComponents = [
    'AboutEdit',
    'ContactInfoEdit',
    'ServicesEdit',
    'SocialMediaEdit',
    'AppoinetementEdit',
    'ScheduleEdit',
    'CvEdit',
    'LinksEdit',
    'ImagesEdit',
    'Pictures',
    'Videos',
  ];
  const [components, setComponents] = useState(initialComponents);

  useEffect(() => {
    fetch(`${apiUrl}/GetComponentsOrder`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${UserToken}`,
      },
      body: JSON.stringify({ user_id: userId }),
    })
      .then(response => response.json())
      .then(result => {
        setComponents(result.data);
      });
  }, []);

  const [message, setMessage] = useState('');


  // Initialize an array to store drag handle references
  const [dragHandleRefs, setDragHandleRefs] = useState(Array(initialComponents.length).fill(null));



  useEffect(() => {
    fetch(`${apiUrl}/GetStatusUser`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${UserToken}`,
      },
      body: JSON.stringify({ userId }),
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.data !== 'Disactivated') {
          setMessage('');
        } else {
          setMessage('Your Account Has Been Disactivated');
        }
      });
  }, []);

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }

    const updatedComponents = [...components];
    const [reorderedComponent] = updatedComponents.splice(result.source.index, 1);
    updatedComponents.splice(result.destination.index, 0, reorderedComponent);

    setComponents(updatedComponents);
    SaveOrderComponents(updatedComponents);
  };

  const [Done, setDone] = useState(false);

  const SaveOrderComponents = (updatedComponents) => {
    fetch(`${apiUrl}/SaveOrderComponents`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${UserToken}`,
      },
      body: JSON.stringify({ orderComponents: updatedComponents }),
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          setDone(!Done);
          console.log(result.message);
        }
      });
  };

  // Function to set the drag handle reference for a component
  const setDragHandleRef = (index, node) => {
    dragHandleRefs[index] = node;
  };

  // Function to render each component based on its name
  const renderComponent = (componentName, provided, snapshot, index) => {
    switch (componentName) {
      case 'AboutEdit':
        return (
          <AboutEdit
            provided={provided}
            dragHandleProps={provided.dragHandleProps}
            dragHandleRef={(node) => setDragHandleRef(index, node)}
          />
        );
      case 'ContactInfoEdit':
        return (
          <ContactInfoEdit
            provided={provided}
            dragHandleProps={provided.dragHandleProps}
            dragHandleRef={(node) => setDragHandleRef(index, node)}
          />
        );
      case 'ServicesEdit':
        return (
          <ServicesEdit
            provided={provided}
            dragHandleProps={provided.dragHandleProps}
            dragHandleRef={(node) => setDragHandleRef(index, node)}
          />
        );
      case 'SocialMediaEdit':
        return (
          <SocialMediaEdit
            provided={provided}
            dragHandleProps={provided.dragHandleProps}
            dragHandleRef={(node) => setDragHandleRef(index, node)}
          />
        );
      case 'AppoinetementEdit':
        return (
          <AppoinetementEdit
            provided={provided}
            dragHandleProps={provided.dragHandleProps}
            dragHandleRef={(node) => setDragHandleRef(index, node)}
          />
        );
      case 'ScheduleEdit':
        return (
          <ScheduleEdit
            provided={provided}
            dragHandleProps={provided.dragHandleProps}
            dragHandleRef={(node) => setDragHandleRef(index, node)}
          />
        );
      case 'CvEdit':
        return (
          <CvEdit
            provided={provided}
            dragHandleProps={provided.dragHandleProps}
            dragHandleRef={(node) => setDragHandleRef(index, node)}
          />
        );
      case 'LinksEdit':
        return (
          <LinksEdit
            provided={provided}
            dragHandleProps={provided.dragHandleProps}
            dragHandleRef={(node) => setDragHandleRef(index, node)}
          />
        );
      case 'ImagesEdit':
        return (
          <ImagesEdit
            provided={provided}
            dragHandleProps={provided.dragHandleProps}
            dragHandleRef={(node) => setDragHandleRef(index, node)}
          />
        );
      case 'Pictures':
        return (
          <Pictures
            provided={provided}
            dragHandleProps={provided.dragHandleProps}
            dragHandleRef={(node) => setDragHandleRef(index, node)}
          />
        );
      case 'Videos':
        return (
          <Videos
            provided={provided}
            dragHandleProps={provided.dragHandleProps}
            dragHandleRef={(node) => setDragHandleRef(index, node)}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div id='main' className='app-main '>
      {message !== '' && (
        <div className='w-full bg-red-200 mb-3 dark:bg-gray-700 p-2 mt-3 rounded'>
          <p className='text-center dark:text-red-500 font-small'>{message}</p>
        </div>
      )}
      <ProfileInfoEdit />
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId='componentList'>
          {(provided) => (
            <div {...provided.droppableProps} ref={provided.innerRef}>
              {components.map((component, index) => (
                <Draggable key={component} draggableId={component} index={index}>
                  {(provided, snapshot) => (
                    <div>
                      <div
                        ref={(node) => {
                          provided.innerRef(node);
                          dragHandleRefs[index] = node; // Update the drag handle reference
                        }}
                        {...provided.draggableProps}
                      >
                        {renderComponent(component, provided, snapshot, index)}
                      </div>
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
      <FooterEdit />
    </div>
  );
}

export default EditProfilePage;
